// extracted by mini-css-extract-plugin
export default {"baseLoader":"loader_baseLoader__HKmxh","baseEllipse":"loader_baseEllipse__2FshS","pulse":"loader_pulse__XrGQE"};